import pkg from "../package.json";
import store from "./store";
import request, {logout} from "./request";
import gtm from './gtm';
import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import NotFound from "./views/NotFound.vue";
import Home from "./views/Home.vue";
import AccountProfile from "./views/Account/Profile.vue";
import AccountHousehold from "./views/Account/Household.vue";
import AccountPeople from "./views/Account/People.vue";
import AccountTags from "./views/Account/Tags.vue";
import AccountRegisterHousehold from "./views/Account/RegisterHousehold.vue";
import WalletBuy from "./views/Wallet/Buy.vue";
import WalletBuyMobile from "./views/Wallet/BuyMobile.vue";
import WalletSend from "./views/Wallet/Send.vue";
import WalletTransactions from "./views/Wallet/Transactions.vue";
import Households from "./views/Households/Index.vue";
import HouseholdsHousehold from "./views/Households/Household.vue";
import HouseholdsSearch from "./views/Households/Search.vue";
import TagInfo from "./views/Tag/Info.vue";
import TagPendingCredits from "./views/Tag/PendingCredits.vue";
import TagTopup from "./views/Tag/Topup.vue";
import TagTransactions from "./views/Tag/Transactions.vue";
import TagTransactionDetails from "./views/Tag/TransactionDetails.vue";
import TapTopup from "./views/Tap/Topup.vue";
import MeterTopup from "./views/Meter/Topup.vue";

Vue.use(Router);

const router = new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Guest pages
    {
      path: "/",
      component: Index
    },
    // Home page
    {
      path: "/home",
      component: Home,
      name: "Home",
      meta:
      {
       title: "Home",
       authRequired: true
      }
    },
    // Account pages
    {
      path: "/account/profile",
      component: AccountProfile,
      meta:
      {
       title: "Profile",
       authRequired: true
      }
    },
    {
      path: "/account/household",
      component: AccountHousehold,
      meta:
      {
       title: "Household",
       authRequired: true
      }
    },
    {
      path: "/account/people",
      component: AccountPeople,
      meta:
      {
       title: "People",
       authRequired: true
      }
    },
    {
      path: "/account/tags",
      component: AccountTags,
      meta:
      {
       title: "Tags",
       authRequired: true
      }
    },
    {
      path: "/account/register-household",
      component: AccountRegisterHousehold,
      meta:
      {
       title: "RegisterMyHousehold",
       authRequired: true
      }
    },
    // Wallet pages
    {
      path: "/wallet/buy",
      component: WalletBuy,
      meta:
      {
       title: "BuyingCredit",
       authRequired: true
      }
    },
    {
      path: "/wallet/buy/mobile",
      component: WalletBuyMobile,
      meta:
      {
       title: "BuyingCredit",
       authRequired: true
      }
    },
    {
      path: "/wallet/send",
      component: WalletSend,
      meta:
      {
       title: "SendingCredit",
       authRequired: true
      }
    },
    {
      path: "/wallet/send/:_callingCode.:_mobile/:_amount/:_currency",
      component: WalletSend,
      props: true,
      meta:
      {
       title: "SendingCredit",
       authRequired: true
      }
    },
    {
      path: "/wallet/send/:_callingCode.:_mobile",
      component: WalletSend,
      props: true,
      meta:
      {
       title: "SendingCredit",
       authRequired: true
      }
    },
    {
      path: "/wallet/transactions",
      component: WalletTransactions,
      meta:
      {
       title: "Transactions",
       authRequired: true
      }
    },
    // Tag pages
    {
      path: "/tag/pending-credits/:_nfcId",
      component: TagPendingCredits,
      props: true,
      meta:
      {
       title: "PendingCredits",
       authRequired: true
      }
    },
    {
      path: "/tag/topup",
      component: TagTopup,
      meta:
      {
       title: "Topup",
       authRequired: true
      }
    },
    {
      path: "/tag/topup/:_nfcId/:_amount/:_currency",
      component: TagTopup,
      props: true,
      meta:
      {
       title: "Topup",
       authRequired: true
      }
    },
    {
      path: "/tag/topup/:_nfcId",
      component: TagTopup,
      props: true,
      meta:
      {
       title: "Topup",
       authRequired: true
      }
    },
    {
      path: "/tag/transactions/:_nfcId",
      component: TagTransactions,
      props: true,
      meta:
      {
       title: "Transactions",
       authRequired: true
      }
    },
    {
      path: "/tag/transaction-details/:_nfcId",
      component: TagTransactionDetails,
      props: true,
      meta:
      {
       title: "Transactions",
       authRequired: true
      }
    },
    {
      path: "/tag/info/:_nfcId",
      component: TagInfo,
      props: true,
      meta:
      {
       title: "Tag"
      }
    },
    // Tap pages
    {
      path: "/tap/topup",
      component: TapTopup,
      meta:
      {
       title: "Topup",
       authRequired: true
      }
    },
    // Meter pages
    {
      path: "/meter/topup",
      component: MeterTopup,
      meta:
      {
       title: "Meter",
       authRequired: true
      }
    },
    // Household pages
    {
      path: "/households",
      component: Households,
      name: "Households",
      meta:
      {
       title: "Households",
       authRequired: true
      }
    },
    {
      path: "/households/search",
      component: HouseholdsSearch,
      meta:
      {
       title: "SearchHousehold",
       authRequired: true
      }
    },
    {
      name: "Household",
      path: "/households/:_householdId",
      component: HouseholdsHousehold,
      props: true,
      meta:
      {
       title: "Household",
       authRequired: true
      }
    },
    {
      path: "/reset-password",
      beforeEnter(to, from, next) {
        window.location.href = "https://accounts.ewater.services";
      }
    },

    // Not found handler
    {
      path: "/not-found",
      component: NotFound,
      meta:
      {
       title: "NotFound"
      }
    },
    {
      path: "*",
      redirect: "/not-found"
    }
  ]
});

// This callback runs before every route change, including on page load.
router.beforeEach(async (to, from, next) =>
{
  if(to.meta.title)
  {
    document.title = `${router.app.$t(to.meta.title)} | ${pkg.name}`;
  }

  if(!to.params._persistNotification)
  {
    store.commit("updateState", {name: "notification", value: {show: false, text: null, className: null}});
  }
  
  if(to.path == "/" && store.state.user)
  {
    router.replace("/home");
  }

  else
  {
    next();
  }
});

router.afterEach((to, from) => {
  gtm.logPage(to.path);
})

export default router;